module.exports = __webpack_public_path__ + "static/media/truckicon.0c1c697b.svg";